import { PORTAL_BASE_URL, WEBSITE_BASE_URL } from "../../../env";
import React from "react";


export const plans = [
  {
    title: "Free trial",
    subtitle: "For anyone",
    description:
      "Try our platform to see how easy it is to generate AI models, design scenes, and render images.",
    price: "Free",
    annualPeriod: "",
    monthlyPeriod: "14-day limited trial",
    buttonText: "Start your free trial",
    buttonLink: PORTAL_BASE_URL + "/register?redirectURL=select-subscription&plan=free_trial&plan_type=subscription",
    buttonClassName: "free-trial-button",
    featuresHeading: "Includes:",
    features: [
      "3 AI-generated models",
      "Unlimited AI images",
      "AR view in room",
      "3D player",
      "Sharing and cloud storage",
    ],
    enhanced_features: [],
    feature_tag: [
    "BETA", "BETA", "", "",""
    ],
    additional_desc: "",
    get_more_toggle: false,
    package_type: "Free",
    plan_name: 'free_trial',
    plan_plus_name: ''
  },
  {
    title: "ALL3D Starter",
    subtitle: "For AI-curious sellers",
    description:
      "Quickly generate AI models and lifestyle images with prompts featuring your products.",
    price: "$25",
    annualPeriod: "/month billed annually",
    monthlyPeriod: "Or $27.50/month billed monthly",
    price_plus: "$99",
    monthlyPlusPeriod: "Or $110/month billed monthly",
    buttonText: "Sign up for Starter",
    buttonTextEnhanced: "Sign up for Starter+",
    buttonLink: PORTAL_BASE_URL + "/register",
    discount: "Save 10% on annual billing",
    featuresHeading: "Includes monthly:",
    features: [
      "2 AI-generated models",
    ],
    enhanced_features: ["10 AI-generated models"],

    feature_tag: [
      "BETA"
    ],
    featuresHeadingSection2: "Plus!",
    featuresSection2: [
      "Unlimited AI images",
      "AR view in room",
      "3D player",
      "Sharing and cloud storage",
      "1 user license",
    ],
    enhanced_features_2: ["Unlimited AI images",
      "AR view in room",
      "3D player",
      "Sharing and cloud storage",
      "1 user license",],
    feature_tag2: [
      "BETA", "", "", "",
    ],
    additional_desc: "Upgrade any AI-generated model with optional 3D artist refinement at $125 per model, pay-as-you-go.",
    tableData: [
      { service: "3D/AR model creation", value: "12" },
      { service: "Product images", value: "32" },
      { service: "Lifestyle images", value: "20" },
      { service: "360 spins", value: "12" },
      { service: "AR View in room", value: "12" },
    ],
    get_more_toggle: true,
    get_more_text: "Get more with ",
    package_type: "Starter",
    plan_name: 'starter',
    plan_plus_name: 'starter_plus'
  },
  {
    title: "ALL3D Growth",
    subtitle: "For SMB sellers",
    description:
      "Create photorealistic 3D models and custom lifestyle images approved for ecommerce use.",
    price: "$449",
    price_plus: "$899",
    annualPeriod: "/month billed annually",
    monthlyPeriod: "Or $495/month billed monthly",
    monthlyPlusPeriod: "Or $990/month billed monthly",
    buttonText: "Sign up for Growth",
    buttonTextEnhanced: "Sign up for Growth+",

    buttonLink: PORTAL_BASE_URL + "/register",
    discount: "Save 10% on annual billing",
    featuresHeading: "Includes monthly:",
    features: [
      "2 photorealistic models",
      "8 product images",
      "2 custom lifestyle images using Scene Creator",
      "Up to 4 product variations"
    ],
    enhanced_features: ["4 photorealistic models",
      "16 product images",
      "4 custom lifestyle images using Scene Creator",
      "Up to 8 product variations"],
    feature_tag: [
      "", "", "", ""
    ],
    additional_desc: "",
    featuresHeadingSection2: "Plus!",
    featuresSection2: [
      "Unlimited AI images",
      "AR view in room",
      "3D player & API integration",
      "Sharing and cloud storage",
      "1 user license",
    ],
    enhanced_features_2: [
      "Unlimited AI images",
      "AR view in room",
      "3D player & API integration",
      "Sharing and cloud storage",
      "2 user licenses",
    ],
    feature_tag2: [
      "BETA", "", "", "", ""
    ],
    tableData: [
      { service: "3D/AR model creation", value: "24" },
      { service: "Product images", value: "64" },
      { service: "Lifestyle images", value: "40" },
      { service: "360 spins", value: "24" },
      { service: "AR View in room", value: "24" },
    ],
    additional_desc: "",
    get_more_toggle: true,
    get_more_text: "Get more with ",
    package_type: "Growth",
    plan_name: 'growth',
    plan_plus_name: 'growth_plus'
  },
  {
    title: "ALL3D Enterprise",
    subtitle: "For Enterprise Customers",
    description:
      "Give your team access to create and collaborate on all of your 3D ecommerce assets in one place.",
    price: "Enterprise Plan",
    annualPeriod: "",
    monthlyPeriod: "Annual Savings Plan",
    buttonText: "Let's Talk",
    buttonLink: `${WEBSITE_BASE_URL}/contact-us?showBusinessFields=true`,
    featuresHeading: "Includes annual plan of our 3D services, plus:",
    enhanced_features: [],
    enhanced_features_2: [],
    features: [
      "Unlimited AI images",
      "AR view in room",
      "3D player & API integration",
      "3D configurator",
      "Collaboration tool",
      "Project & asset management",
      "Managed design services",
      "Account manager",
      "Dedicated support",
      "Sharing & cloud storage",
      "Multiple user licenses"
    ],
    feature_tag: [
      "BETA", "", "", "", "", "", "", "", "", "", ""
    ],
    additional_desc: "",
    get_more_toggle: false,
    get_more_text: "Get more with ",
    package_type: "Enterprise",
    plan_name: 'enterprise',
    plan_plus_name: ''
  },
];

export const bundles = [
  {
    title: "AI Creator",
    description:
      "Ideal for quickly creating AI-prompted product images for an ecommerce listing.",
    price: 14,
    buttonText: "Buy AI Creator",
    featuresHeading: "Includes:",
    features: [
    "1 AI-generated model",
    "Unlimited AI images",
    "AR view in room",
    "3D player",
    "Sharing & cloud storage",
    ],
    feature_tag: [
      "BETA", "BETA", "", "", ""
    ],
    additional_desc: "Upgrade any AI-generated model with optional 3D artist refinement at $125 per model, pay-as-you-go.",
    package_type: 'AI Creator',
    name: 'ai-creator'
  },
  {
    title: "PDP Basic",
    alert: "Popular with Amazon sellers",
    description: "Ideal for a creating a product listing with 3D/AR integration at an affordable price.",
    price: 139,
    buttonText: "Buy PDP Basic",
    featuresHeading: "Includes:",
    features: [
      "1 photorealistic model",
      "Unlimited AI images",
      "AR view in room",
      "3D player & API integration",
      "Sharing & cloud storage",
    ],
    feature_tag: [
      "", "BETA", "", "", ""
    ],
    package_type: 'PDP Basic',
    name: 'pdp_basic'
  },
  {
    title: "PDP Pro",
    description:
      "Ideal for optimizing listings with 3D/AR models and high-quality images and assets.",
    price: 399,
    buttonText: "Buy PDP Pro",
    featuresHeading: "Includes:",
    features: [
      "1 photorealistic model",
      "4 product images",
      "1 custom lifestyle image using Scene Creator",
      "Unlimited AI images",
      "AR view in room",
      "3D player & API integration",
      "Sharing & cloud storage",
    ],
    feature_tag: [
      "", "", "", "BETA", "", "", ""
    ],
    package_type: 'PDP Pro',
    name: 'pdp_pro'
  },
];

export const users = [
  {
    icon: "/seller-logos.png",
    title: "Online Sellers",
    description:
      "Get all the images you need for A+ product listings—plus AR for View in Room — all in one easy-to-manage platform.",
  },
  {
    icon: "/basket.svg",
    title: "Online DTC Brands",
    description:
      "Easily create product and lifestyle photos to use on your ecommerce site and marketing on social media channels.",
  },
  {
    icon: "/solar_shop.svg",
    title: "Large Retailers",
    description:
      "Get all your manufacturer models in one place to create multi-vendor lifestyle content quickly and easily.",
  },
  {
    icon: "/clarity_factory.svg",
    title: "Manufacturers",
    description:
      "Create prototypes of products, show your products in beautiful spaces and generate all your virtual content in one place.",
  },
  {
    icon: "/pencil_scale.svg",
    title: "Interior Designers",
    description:
      "Create photorealistic images, 360s and 3D tours of designs for your clients. Quickly create engaging social media content.",
  },
  {
    icon: "/real_estate.svg",
    title: "Real Estate Agencies",
    description:
      "Create 3D room tours and photorealistic staging images of high-profile listings to reach more potential clients.",
  },
];

export const brands = [
  { name: "Aleko", path: "/brands/Aleko.png", height: 32 },
  { name: "Amazon", path: "/brands/Amazon.png", height: 32 },
  { name: "Casper", path: "/brands/Casper.png", height: 32 },
  { name: "Flexsteel", path: "/brands/Flexsteel.png", height: 32 },
  { name: "The Home Depot", path: "/brands/Home-Depot.png", height: 48 },
  { name: "Hooker Furnishings", path: "/brands/Hooker-Furnishings.png", height: 32 },
  { name: "Linon", path: "/brands/Linon.png", height: 48 },
  { name: "Million Dollar Baby Co.", path: "/brands/Million-Dollar-Baby-Co.png", height: 48 },
  { name: "Restoration Hardware", path: "/brands/Restoration-Hardware.png", height: 48 },
  { name: "Rough Country", path: "/brands/Rough-Country.png", height: 32 },
  { name: "Sunpan", path: "/brands/Sunpan.png", height: 32 },
  { name: "Skyline Furniture", path: "/brands/Skyline-Furniture.png", height: 48 },
  { name: "Telescope", path: "/brands/Telecope.png", height: 48 },
  { name: "Uttermost", path: "/brands/Uttermost.png", height: 32 },
  { name: "Walmart", path: "/brands/Walmart.png", height: 32},
];

export const features = [
  {
    title: "3D/AR Model Creation",
    description:
      "It all starts with creating accurate 3D models of your products and variants.",
    image: "/features/feature_chair.png",
    model: true,
    poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/28798_FrontAngled.jpg",
    src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/28798.glb",
    featuresList: [
      {
        title: "AI-generated models",
        description:
          "Image-to-3D product model creation in minutes from a single photo",
      },
      {
        title: "Photorealistic models",
        description:
          "High-quality product models refined by a 3D artist to use in ecommerce listings",
      },
      {
        title: "Product variants",
        description:
          "Multiple variants or SKUs of your product in different colors, materials, etc.",
      },
      {
        title: "3D space models",
        description:
          "Single or connected rooms to create lifestyles, 360 room spins, or 3D tours",
      },
    ],
  },
  {
    title: "Photorealistic Images & Assets",
    no_border: true,

    description:
      "Manage all your assets in one place – from product and lifestyle imagery to AR view in room.",
    image: "/makeup.png",
    featuresList: [
      {
        title: "AI Images",
        description:
          "Real-time images created from a single photo and a descriptive prompt",
      },
      {
        title: "Product images",
        description:
          "Clear product shots in multiple angles on a white or gray background, with or without dimensions",
      },
      {
        title: "Lifestyle images",
        description:
          "Custom photorealistic images of your product set in a room scene",
      },
      {
        title: "AR view in room",
        description: "Uses an AR model to allow the View in Room feature",
      },
    ],
  },
  {
    title: "Scene Creator Tool",
    no_border: true,
    description:
      "Scene Creator places your product into a styled vignette or room scene to create lifestyle images showing your product’s scale and use.",
    image: "/scene-creator-tool.png",
    featuresList: [
      {
        title: "Lifestyle images",
        description:
          "Photorealistic images of your product set in a room scene helping to show scale and use",
      },
      {
        title: "3D tour of spaces",
        description:
          "A 360 spin of a room scene showcasing your product or designed space",
      },
      {
        title: "Design services available",
        description:
          "Work with a designer to style custom scenes for your product’s lifestyle images",
        isAdd: true,
      },
      {
        title: "Training available",
        description:
          "Get your team up to speed faster using our platform with a training session",
        isAdd: true,
      },
    ],
  },
  {
    title: "Free ALL3D Store Models",
    description:
      "You’ll have free access to the ALL3D store to use a wide variety of 3D models including products, props, spaces, and scene templates.",
    image: "/features/store_models.png",
    featuresList: [
      {
        title: "Free product & prop models",
        description:
          "Browse a variety of products and props to style with your product for a lifestyle image",
      },
      {
        title: "Free spaces",
        description:
          "Place your products and other props into a space to create a unique lifestyle environment",
      },
      {
        title: "Free styled scene templates",
        description:
          "Choose from a variety of styled scenes to place your product for a quick lifestyle image",
      },
    ],
  },
  {
    title: "Collaboration, Sharing, & Storage",
    description:
      "With your asset library in the cloud, you can easily share and collaborate with your team on your 3D models, scenes, and images.",
    image: "/features/cloud_storage.png",
    featuresList: [
      {
        title: "Share and collaborate",
        description:
          "Ability to share and collaborate with your team on models and designs",
      },
      {
        title: "Cloud storage",
        description:
          "Unlimited cloud storage for your model and asset libraries",
      },
    ],
  },
];

export const faqs = [
  {
    question: "How does the free trial work?",
    answer:
      "ALL3D offers a free trial, giving you access to key platform features such as AI Creation, model creation, silos, and lifestyle images. During the trial, you can explore the platform without commitment. You can create a limited number of item models and lifestyles. Once the trial ends, you can continue using ALL3D by subscribing to a plan or purchasing individual assets. Any work created during the trial remains accessible if you upgrade.",
  },
  {
    question: "What features can I access once I have an ALL3D account?",
    answer:
      <div>With an ALL3D account, you gain access to a powerful suite of 3D visualization tools, including:
        <ul>
          <li>
            AI Creator</li>
          <li>3D Model Creation – Upload reference images to create detailed 3D models</li>
          <li> Product Images – High-resolution cutout images of your product</li>
          <li> Lifestyle Images – Place products in realistic, fully customizable settings</li>
          <li> Scene Creator – Build and modify 3D environments for your products</li>
          <li> Collaboration Tools – Share, comment, and review assets with your team</li>
          <li>Add-On Purchases – Buy additional assets, features, and services as needed</li>
        </ul>
      </div>,
  },
  {
    question: "How do subscriptions work?",
    answer:
      <div>
        ALL3D subscriptions are designed to offer flexibility. Here’s what’s included:
        <ul>
          <li>Annual and Monthly Plans – Choose between upfront annual billing or month-to-month payments</li>
          <li>Included Credits – Subscription tiers come with a set number of assets each month</li>
          <li>Payment Options – Pay by credit card; enterprise accounts may have invoice options</li>
          <li>Credit Expiration – Monthly credits do not roll over; they reset at the start of each billing cycle</li>
        </ul>
      </div>,
  },
  {
    question:
      "Are there additional costs associated with a subscription? What if I need less or more each month?",
    answer:
      "Your subscription includes a defined number of models and images. If you need more than your plan provides, you can purchase additional assets as needed. If you don’t use all your included assets, they do not roll over, but you can adjust your plan in the next billing cycle to better fit your needs.",
  },
  {
    question: "How does an enterprise account work?",
    answer:
      <div>
        Enterprise accounts are tailored to large-scale needs and offer:
        <ul>
          <li>
            Custom Pricing – Based on company size, asset volume, and usage requirements</li>
          <li>Managed Services – Design assistance and project management</li>
          <li>Multiple Seats – Grant access to teams with role-based permissions</li>
          <li>Advanced Security & Compliance – Enterprise-grade data protection</li>
          <li>Priority Access & Support – Dedicated account management</li>
          <li>API Access – Integrate with your existing tools and workflows</li>
        </ul>
      </div>,
  },
  {
    question: "What if I need something not included in a package?",
    answer:
      "Our packages cover the most common needs, but you can purchase additional assets separately. Once you have an account, our team can help customize your plan to include the specific assets and services you require.",
  },
  {
    question: "Is there training available?",
    answer:
      <div>
        Yes! ALL3D provides several training options:
        <ul>
          <li>ALL3D Office Hours – Weekly session available for anyone to ask questions</li>
          <li>1:1 Training & Design Services – Available as an add-on</li>
          <li>On-Demand Tutorials – Access how-to videos and guides</li>
          <li>Customer Support – Get assistance from our expert team</li>
        </ul>
      </div>,
  },
  {
    question: "What is the cancellation or return policy?",
    answer:
      <div>
        <ul>
          <li>Subscriptions – Cancel anytime before your next billing cycle to avoid charges. Refunds are not provided for unused time.</li>
          <li>Bundles & Add-Ons – Non-refundable once purchased.</li>
          <li>Enterprise Agreements – Cancellation terms are outlined in your contract. Contact your account manager for details.</li>
        </ul>
      </div>,
  },
];

export const PLAN_DETAIL_MODALS = [
  {
    'title': 'ALL3D Free Trial',
    'features': [
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3 AI-generated Models',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Image-to-3D product model in minutes from a single photo'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.jpg',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.jpg',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Start your free trial',
    package_type: "Free",
    plan_name: 'free_trial',
  },
  {
    'title': 'ALL3D Starter Subscription',
    'features': [
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '2 AI-generated Models',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Image-to-3D product model in minutes from a single photo'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.jpg',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.jpg',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '1 User License',
        'subtext': 'User seat available for your platform usage'
      },
    ],
    'button_text': 'Sign up for Starter',
    'upgrade_text': 'Upgrade any AI-generated model with optional 3D artist refinement at $125 per model, pay-as-you-go.',
    package_type: "Starter",
    plan_name: 'starter',
  },
  {
    'title': 'ALL3D Starter+ Subscription',
    'features': [
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '10 AI-generated Models',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Image-to-3D product model in minutes from a single photo'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.jpg',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.jpg',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '1 User License',
        'subtext': 'User seat available for your platform usage'
      },
    ],
    'button_text': 'Sign up for Starter+',
    'upgrade_text': 'Upgrade any AI-generated model with optional 3D artist refinement at $125 per model, pay-as-you-go.',
    plan_plus_name: 'starter_plus'

  },
  {
    'title': 'ALL3D Growth Subscription',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': '2 Photorealistic Models',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'High-quality product models to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/group.png',
        'title': '4 Product Images',
        'subtext': 'Clear product shots on a clean white or gray background'
      },
      {
        'image': '/PricingModal/Custom-Lifestyle1.jpg',
        'title': '8 Lifestyle Images',
        'subtext': 'Custom photorealistic images of your product in a scene'
      },
      {
        'image': '/PricingModal/38512_FrontAngled2.jpg',
        'title': 'Up to 4 Product Variations',
        'subtext': 'Variants of your product in different colors, materials, etc.'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.jpg',
        'title': 'Unlimited AI Images',
        'subtext': 'Clear product shots on a clean white or gray background',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.jpg',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player/API Integration',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '1 User License',
        'subtext': 'User seat available for your platform usage'
      },
    ],
    'button_text': 'Sign Up for Growth',
    package_type: "Growth",
    plan_name: 'growth',
  },
  {
    'title': 'ALL3D Growth+ Subscription',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': '4 Photorealistic Models',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'High-quality product models to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/group.png',
        'title': '8 Product Images',
        'subtext': 'Clear product shots on a clean white or gray background'
      },
      {
        'image': '/PricingModal/Custom-Lifestyle1.jpg',
        'title': '16 Lifestyle Images',
        'subtext': 'Custom photorealistic images of your product in a scene'
      },
      {
        'image': '/PricingModal/38512_FrontAngled2.jpg',
        'title': 'Up to 8 Product Variations',
        'subtext': 'Variants of your product in different colors, materials, etc.'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.jpg',
        'title': 'Unlimited AI Images',
        'subtext': 'Clear product shots on a clean white or gray background',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.jpg',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player/API Integration',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
      {
        'image': '/PricingModal/license.png',
        'title': '2 User Licenses',
        'subtext': 'User seat available for your platform usage'
      },
    ],
    'button_text': 'Sign Up for Growth+',
    plan_plus_name: 'growth_plus'
  },
  {
    'title': 'ALL3D Enterprise Subscription',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': 'Photorealistic Models',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'High-quality product models to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/group.png',
        'title': 'Product Images',
        'subtext': 'Clear product shots on a clean white or gray background'
      },
      {
        'image': '/PricingModal/Custom-Lifestyle1.jpg',
        'title': 'Lifestyle Images',
        'subtext': 'Custom photorealistic images of your product in a scene'
      },
      {
        'image': '/PricingModal/38512_FrontAngled2.jpg',
        'title': 'Product Variations',
        'subtext': 'Variants of your product in different colors, materials, etc.'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.jpg',
        'title': 'Unlimited AI Images',
        'subtext': 'Clear product shots on a clean white or gray background',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.jpg',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player/API Integration',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
      {
        'image': '/PricingModal/configurator.jpeg',
        'title': '3D Configurator',
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
      {
        'image': '/PricingModal/collaboration.png',
        'title': 'Collaboration Tool',
        'subtext': 'Interactive 3D player of your model for ecommerce'
      },
    ],
    'extra_features': [
      {
        'image': '/PricingModal/small_pic.png',
        'title': 'Project & Asset Management',
      },
      {
        'image': '/PricingModal/managed.png',
        'title': 'Managed Design Services',
      },
      {
        'image': '/PricingModal/chat.png',
        'title': 'Account Manager',
      },
      {
        'image': '/PricingModal/support.png',
        'title': 'Dedicated Support',
      },
      {
        'image': '/PricingModal/cloud_small.png',
        'title': 'Sharing & Cloud Storage',
      },
      {
        'image': '/PricingModal/license_small.png',
        'title': 'Multiple user licenses',
      },
    ],
    'button_text': 'Schedule a Demo',
    package_type: "Enterprise",
    plan_name: 'enterprise',
  }
]


export const BUNDLE_DETAIL_MODALS = [
  {
    'title': 'AI Creator Package',
    'features': [
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '1 AI-generated Models',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Image-to-3D product model in minutes from a single photo'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.jpg',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.jpg',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Buy AI Creator',
    'upgrade_text': 'Upgrade any AI-generated model with optional 3D artist refinement at $125 per model, pay-as-you-go.',
      package_type: 'AI Creator',
    name: 'ai_creator'
  },
  {
    'title': 'PDP Basic',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': '1 Photorealistic Model',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'High-quality product model to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.jpg',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.jpg',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Buy PDP Basic',
     package_type: 'PDP Basic',
    name: 'pdp_basic'
  },
  {
    'title': 'PDP Pro',
    'features': [
      {
        'image': '/PricingModal/photorealisticmodels.png',
        'title': '1 Photorealistic Model',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'High-quality product model to use in ecommerce listings'
      },
      {
        'image': '/PricingModal/group.png',
        'title': '4 Product Images',
        'subtext': 'Clear product shots on a clean white or gray background'
      },
      {
        'image': '/PricingModal/Custom-Lifestyle1.jpg',
        'title': '1 Lifestyle Image',
        'subtext': 'Custom photorealistic images of your product in a scene'
      },
      {
        'image': '/PricingModal/AI-Lifestyle1.jpg',
        'title': 'Unlimited AI Images',
        'subtext': 'Real-time images created from a single photo and prompt',
        'beta': true
      },
      {
        'image': '/PricingModal/AR1.jpg',
        'title': 'AR View in Room',
        'subtext': 'Uses an AR model to support the ecommerce View in Room feature'
      },
      {
        'image': '/PricingModal/3dplayer.png',
        'title': '3D Player',
        'model': true,
        poster: "https://d48f7equ64qjl.cloudfront.net/product_assets/perspective_renders/38512_FrontAngled.jpg",
        src: "https://d48f7equ64qjl.cloudfront.net/product_assets/glb/38512.glb",
        'subtext': 'Interactive 3D player of your model'
      },
      {
        'image': '/PricingModal/cloud.png',
        'title': 'Sharing & Cloud Storage',
        'subtext': 'Asset management platform for sharing and storage'
      },
    ],
    'button_text': 'Buy PDP Pro',
     package_type: 'PDP Pro',
    name: 'pdp_pro'
  }
]

export const VIEW_MODAL_DICT = {
  'Free': 'ALL3D Free Trial',
  'Starter': 'ALL3D Starter Subscription',
  'Growth': 'ALL3D Growth Subscription',
  'Enterprise': 'ALL3D Enterprise Subscription',
  'Starter+': 'ALL3D Starter+ Subscription',
  'Growth+': 'ALL3D Growth+ Subscription',
  'AI Creator': 'AI Creator Package',
  'PDP Basic': 'PDP Basic',
  'PDP Pro': 'PDP Pro'
}


export const SERVICE_ADDONS = [
  {
    title: 'Basic training',
    services: [
      {
        'service': '1 hour fast-start Zoom session',
        'fee': '$65'
      }
    ]
  },
  {
    title: 'Customer support',
    services: [
      {
        'service': 'Weekly office hours Zoom session',
        'fee': 'Free'
      },
      {
        'service': '1:1 customer support',
        'fee': '$65/hr'
      }
    ]
  },
  {
    title: 'Design services',
    services: [
      {
        'service': 'Hourly design rate',
        'fee': '$65/hr '
      },
      {
        'service': 'Scene design of products in a space',
        'fee': '$160/scene'
      }
    ]
  },
  {
    title: 'Other 3D Services',
    services: [
      {
        'service': '360 spinner (manual trackpad rotation)',
        'fee': '$80'
      },
      {
        'service': 'MP4 video (auto-rotation of 360)',
        'fee': '$80'
      },
      {
        'service': '3D space model creation',
        'fee': '$200-$750'
      }
    ]
  },
]